import React from 'react'
import './_SueItemUpdate.css';

interface Props {
    garageDetails: any;
    onGarageParamChange: (e: any, paramName: string) => void;
}

const AppraiserDetails = (props: Props) => {
    return (
        <div className='white-block white-block-fixed-height'>
            <section className=''>
                <div className='section-sue-title'>
                    פרטי שמאי
                </div>
                <div className="parameter-row">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                שם השמאי
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorName} onChange={(e: any) => props.onGarageParamChange(e, 'assessorName')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                מס' טלפון
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorPhoneNumber} onChange={(e: any) => { props.onGarageParamChange(e, 'assessorPhoneNumber') }}
                                 onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                טלפון נייד
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorMobilePhoneNumber} onChange={(e: any) => { props.onGarageParamChange(e, 'assessorMobilePhoneNumber') }}
                                 onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                פקס
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorFaxNumber} onChange={(e: any) => {props.onGarageParamChange(e, 'assessorFaxNumber') }}
                                 onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                דוא"ל
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorEmail} onChange={(e: any) => props.onGarageParamChange(e, 'assessorEmail')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="parameter-row single-item">
                    <div className="parameter-item">
                        <div className="field">
                            <div className="title">
                                כתובת
                            </div>
                            <div className="value">
                                <input type="text" value={props.garageDetails && props.garageDetails.assessorAddress} onChange={(e: any) => props.onGarageParamChange(e, 'assessorAddress')} onBlur={(e: any) => { }} />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default AppraiserDetails